import { AxiosInstance } from 'axios';
import axiosClient from './axiosClientConfig';
import { HttpResponse } from 'interfaces/httpClient';
import {
	ActionStatus,
	CaseFilterListData,
	ClientDirectoryData,
	ClientFilterListData,
	MessageFilterType,
	SegmentationFilterListData,
} from '@/interfaces';

class ClientDirectory {
	constructor(private client: AxiosInstance) {}

	async getClientDirectoryList(
		page: number,
		limit: number,
		search?: string,
		clientId?: string,
		segmentId?: string[],
		isOrderAlph?: boolean,
		caseId?: string,
		totalCase?: number,
		totalTaskClient?: number,
		totalTaskLawyer?: number,
		actionStatusLawyer?: ActionStatus,
		actionStatusClient?: ActionStatus,
		totalMessage?: number,
		messageFilter?: MessageFilterType
	): Promise<HttpResponse<ClientDirectoryData>> {
		const auxParams = [];
		search && auxParams.push('search=' + search);
		clientId && auxParams.push('clientId=' + clientId);
		segmentId &&
			segmentId.forEach((id) => {
				auxParams.push('segmentId=' + id);
			});
		isOrderAlph && auxParams.push('isOrderAlph=' + isOrderAlph);
		caseId && auxParams.push('caseId=' + caseId);
		totalCase !== undefined && auxParams.push('totalCase=' + totalCase);
		totalTaskClient !== undefined &&
			auxParams.push('totalTaskClient=' + totalTaskClient);
		totalTaskLawyer !== undefined &&
			auxParams.push('totalTaskLawyer=' + totalTaskLawyer);
		actionStatusLawyer &&
			auxParams.push('actionStatusLawyer=' + actionStatusLawyer);
		actionStatusClient &&
			auxParams.push('actionStatusClient=' + actionStatusClient);
		totalMessage !== undefined &&
			auxParams.push('totalMessage=' + totalMessage);
		messageFilter && auxParams.push('messageFilter=' + messageFilter);
		const params = auxParams.join('&');
		return this.client.get(
			params.length > 0
				? `/client-directory?page=${page}&limit=${limit}&${params}`
				: `/client-directory?page=${page}&limit=${limit}`
		);
	}

	async getActionFilter(): Promise<HttpResponse<ActionStatus[]>> {
		return this.client.get('/client-directory/action-filters');
	}
	async getMessageFilter(): Promise<HttpResponse<MessageFilterType[]>> {
		return this.client.get('/client-directory/message-filter');
	}
	async getClientListFilter(
		page: number,
		limit: number
	): Promise<HttpResponse<ClientFilterListData>> {
		return this.client.get(
			`/client-directory/client-list?page=${page}&limit=${limit}`
		);
	}
	async getCaseListFilter(
		page: number,
		limit: number
	): Promise<HttpResponse<CaseFilterListData>> {
		return this.client.get(
			`/client-directory/cases-list?page=${page}&limit=${limit}`
		);
	}
	async getSegmentationListFilter(
		page: number,
		limit: number
	): Promise<HttpResponse<SegmentationFilterListData>> {
		return this.client.get(
			`/client-directory/segmentation-list?page=${page}&limit=${limit}`
		);
	}
}

export const clientDirectoryService = new ClientDirectory(axiosClient);
